"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInputSelection = getInputSelection;
exports.isInputFocused = isInputFocused;
exports.setInputSelection = setInputSelection;
function setInputSelection(input, start, end) {
  if (end === undefined) {
    end = start;
  }
  input.setSelectionRange(start, end);
}
function getInputSelection(input) {
  const start = input.selectionStart || 0;
  const end = input.selectionEnd || 0;
  return {
    start,
    end,
    length: end - start
  };
}
function isInputFocused(input) {
  if (!input) {
    return false;
  }
  const inputDocument = input.ownerDocument;
  return (inputDocument === null || inputDocument === void 0 ? void 0 : inputDocument.hasFocus()) && inputDocument.activeElement === input;
}